<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item v-if="!accessLevel" :link="{name: 'Página Principal', icon: 'now-ui-icons design_app', path: '/dashboard'}"></sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Relatórios', icon: 'now-ui-icons business_chart-bar-32'}">
          <sidebar-item :link="{name: 'Venda por Data', path: '/vendas'}"></sidebar-item>
          <sidebar-item :link="{name: 'Venda por Produtos', path: '/vendasProdutos'}"></sidebar-item>
          <sidebar-item :link="{name: 'Venda por Forma de Pagamento', path: '/vendasPagamentos'}"></sidebar-item>
          <sidebar-item :link="{name: 'Venda por Horário', path: '/vendasHorarios'}"></sidebar-item>
          <sidebar-item v-if="hasVendedor" :link="{name: 'Venda por Vendedor', path: '/vendedores'}"></sidebar-item>
          <sidebar-item :link="{name: 'Relatório Geral', path: '/relatorioGeral'}"></sidebar-item>
          <sidebar-item  v-if="moduloVendaFranquia" :link="{name: 'Relatório de Venda da Franquia', path: '/vendasCategorias'}"></sidebar-item>
          <sidebar-item  v-if="moduloVendaFranquia" :link="{name: 'Relatório de Compra da Franquia', path: '/vendasCategoriasFiscal'}"></sidebar-item>
          <sidebar-item :link="{name: 'Caixas', path: '/caixas'}"></sidebar-item>
          <sidebar-item v-if="modulo_telemetria" :link="{name: 'Telemetria', path: '/telemetria'}"></sidebar-item>
          <sidebar-item v-if="modulo_voucher" :link="{name: 'Troca de Mercadoria', path: '/trocaMercadoria'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Cadastros', icon: 'now-ui-icons design-2_ruler-pencil'}">
          <sidebar-item :link="{name: 'Categorias', path: '/categorias'}" v-if="!accessLevel && moduloCategoria"></sidebar-item>
          <sidebar-item :link="{name: 'Produtos', path: '/produtos'}"></sidebar-item>
          <sidebar-item v-if="!accessLevel" :link="{name: 'Clientes', path: '/clientes'}"></sidebar-item>
          <sidebar-item v-if="!accessLevel" :link="{name: 'Fornecedores', path: '/fornecedores'}"></sidebar-item>
          <sidebar-item v-if="!accessLevel" :link="{name: 'Formas de Pagamento', path: '/formaPagamento'}"></sidebar-item>
          <sidebar-item v-if="moduloCategoriaFiscal" :link="{name: 'Categoria de Compra', path: '/categoriaFiscal'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="!accessLevel" :link="{name: 'Financeiro', icon: 'now-ui-icons business_money-coins'}">
          <sidebar-item :link="{name: 'Lançamentos', path: '/financeiro/extrato'}"></sidebar-item>
          <sidebar-item :link="{name: 'Fluxo de Caixa/Competência', path: '/financeiro/fluxo'}"></sidebar-item>
          <sidebar-item :link="{name: 'Categorias Financeiras', path: '/financeiro/categorias'}"></sidebar-item>
          <sidebar-item :link="{name: 'Formas de Pagamento', path: '/financeiro/formas-pagamento'}"></sidebar-item>
          <sidebar-item :link="{name: 'Contas Bancárias', path: '/financeiro/contas'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{name: 'Fiscal', icon: 'now-ui-icons design_bullet-list-67'}">
          <sidebar-item v-if="!modulo_mfe" :link="{name: 'Vendas', path: '/fiscal'}"></sidebar-item>
          <sidebar-item v-if="modulo_mfe" :link="{name: 'Vendas', path: '/cfe'}"></sidebar-item>
          <sidebar-item :link="{name: 'Entrada de Nota', path: '/notasCompra'}"></sidebar-item>
          <sidebar-item v-if="moduloRobo" :link="{name: 'Notas de Compra', path: '/notasCompraRobo'}"></sidebar-item>
          <sidebar-item :link="{name: 'Inventário', path: '/inventario'}"></sidebar-item>
          <sidebar-item :link="{name: 'Relatório por CFOP', path: '/vendas_cfop'}"></sidebar-item>
          <sidebar-item :link="{name: 'Relatório de PIS/COFINS', path: '/relatorio-pis'}"></sidebar-item>

        </sidebar-item>

        <sidebar-item :link="{name: 'Ultima Sincronização:'+ultima_sinc, path: '/fiscal'}"></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <router-view name="header"></router-view>

      <div :class="{content: !$route.meta.hideContent}" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>


</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar'
  import 'perfect-scrollbar/css/perfect-scrollbar.css'
  import moment from 'moment'
  function hasElement (className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar (className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import { EventBus } from '@/services/EventBus'
  import {SlideYDownTransition, ZoomCenterTransition} from 'vue2-transitions'
  

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      SlideYDownTransition,
      ZoomCenterTransition,
      moment
    },
    data() {
      return {
        user: null,
        ultima_sinc:localStorage.getItem('ultima_sinc'),
        hasFinanceiro: false,
        hasVendedor: false,
        moduloCategoria: localStorage.getItem('config_modulo_categoria') == "true" ? true : false,
        moduloRobo: false,
        moduloVendaFranquia: false,
        moduloCategoriaFiscal: localStorage.getItem('config_modulo_categoria_fiscal') == "true" ? true : false,
        modulo_telemetria: localStorage.getItem('modulo_telemetria') == "true" ? true : false,
        modulo_voucher: localStorage.getItem('config_modulo_voucher') == "true" ? true : false,
        modulo_mfe: localStorage.getItem('config_modulo_mfe') == "true" ? true : false,
        accessLevel: null,
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    },
    mounted () {
      this.accessLevel = window.accessLevel;

      EventBus.$on('hasFinanceiro', res => {
        if(res == "true") {
          this.hasFinanceiro = true;
        } else {
          this.hasFinanceiro = false;
        }
      })

      EventBus.$on('hasVendedor', res => {
        if(res == "true") {
          this.hasVendedor = true;
        } else {
          this.hasVendedor = false;
        }
      })

      EventBus.$on('moduloCategoria', res => {
        if(res == "true") {
          if(!window.accessLevel) {
            this.moduloCategoria = true;
          }
        } else {
          this.moduloCategoria = false;
        }
      })

      EventBus.$on('moduloVendaFranquia', res => {
        if(res == "true") {
          if(!window.accessLevel) {
            this.moduloVendaFranquia = true;
          }
        } else {
          this.moduloVendaFranquia = false;
        }
      })

      EventBus.$on('moduloRobo', res => {
        if(res == "true") {
          this.moduloRobo = true;
        } else {
          this.moduloRobo = false;
        }
      })

      EventBus.$on('modulo_telemetria', res => {
        if(res == "true") {
          this.modulo_telemetria = true;
        } else {
          this.modulo_telemetria = false;
        }
      })

      EventBus.$on('config_modulo_voucher', res => {
        if(res == "true") {
          this.modulo_voucher = true;
        } else {
          this.modulo_voucher = false;
        }
      })

      if(localStorage.getItem('config_modulo_contas')) {
        this.hasFinanceiro = localStorage.getItem('config_modulo_contas') == 'true' ? true : false
      }

      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on')
      } else {
        docClasses.add('perfect-scrollbar-off')
      }

      let rawUser = localStorage.getItem('user');

      try {
        if(rawUser) {
          this.user = JSON.parse(rawUser)
        }
      } catch(e) {
        console.error(e)
      }
    }
  }

</script>
<style lang="scss">
  $scaleSize: .95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }
  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }
  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }
  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
</style>
